import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { PaymentScenarionConditionKindEnum } from '@zaoblako/shared/modules/task/enum/payment.scenarion.condition.kind.enum';
import { PaymentScenarionConditionKindEnumI18n } from '@zaoblako/shared/modules/task/i18n/payment-scenarion-condition-kind.enum.i18n';

@Pipe({
  name: 'paymentTaskScenarioConditionKindName',
  standalone: true
})
export class PaymentTaskScenarioConditionKindNamePipe implements PipeTransform {
  public transform(kind: PaymentScenarionConditionKindEnum): string {
    return PaymentScenarionConditionKindEnumI18n[I18nLocalesEnum.RU_RU][kind] || '';
  }
}
